/**
 * What happens to a dispute after it is opened: jury vote, cancellation, appeal.
 *
 * All three are per-order, so every screen passes the order's `_id` as
 * `instanceId` — two disputes must never share a journal row.
 *
 * `vote` and `cancelDispute` declare no on-chain verifier: the router's reads
 * for them are keyed by `disputeId`, which lives in the log of the very
 * transaction we would be looking for. Recovery resolves those by hash (the
 * ordinary case) with the bounded nonce scan behind it.
 *
 * The APPEAL step is different and does declare one. `openAppeal` has NO
 * re-entry guard in the router — unlike `openDispute`, which reverts
 * `RequestHasDispute()` — so a second call really does transfer another 10 DAI.
 * Nothing on-chain will catch a duplicate, which makes `getRequest().phase == 2`
 * the closest thing to a guard we have. See
 * docs/DISPUTE-APPEAL-FEE-DURABILITY-PLAN.md §0.2.
 */

import { registerFlow } from "../flows";
import { approveSatisfied, stageAlreadyOpen } from "../verifiers";
import { REQUEST_PHASE_APPEAL } from "./openDispute";

export const VOTE_FLOW = "vote";
export const VOTE_STEPS = { VOTE: "vote" };

export const CANCEL_DISPUTE_FLOW = "cancelDispute";
export const CANCEL_DISPUTE_STEPS = { CANCEL: "cancel" };

export const OPEN_APPEAL_FLOW = "openAppeal";
export const OPEN_APPEAL_STEPS = { APPROVE: "approve", APPEAL: "appeal" };

registerFlow({ id: VOTE_FLOW, steps: { [VOTE_STEPS.VOTE]: {} } });
registerFlow({
  id: CANCEL_DISPUTE_FLOW,
  steps: { [CANCEL_DISPUTE_STEPS.CANCEL]: {} },
});
registerFlow({
  id: OPEN_APPEAL_FLOW,
  steps: {
    [OPEN_APPEAL_STEPS.APPROVE]: { verifyOnChain: approveSatisfied },
    [OPEN_APPEAL_STEPS.APPEAL]: {
      verifyOnChain: stageAlreadyOpen(REQUEST_PHASE_APPEAL),
    },
  },
});
